import { styled } from '../../../shared/theming-sc'

export const StyledCaret = styled.button.attrs({
  style: ({angle}) => ({
    transform: `rotate(${angle}deg)`
  })
})`
  background: transparent;
  border: none;
  outline: none !important;
  position: absolute;
  right: 1px;
  top: 2px;
  height: 58px;
  width: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 1;
  transition: transform 0.45s cubic-bezier(0.4,0.9,0,1), opacity 0.125s linear;
`
